import { Injectable } from '@angular/core';
import { NotificationsApiService } from '../../../../supplier-portal/shared/services/src/lib/notifications/notifications-api.service';
import {BehaviorSubject, of} from 'rxjs';
import {
  IPaginatedResponse,
  IUserNotificationDetails,
  NotificationType,
} from '@boma/supplier-portal/shared/entities';
import { pairwise, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { getSelectedOrganizationInfo } from '@boma/supplier-portal/shared/state';

@Injectable({
  providedIn: 'root',
})
export class UserNotificationTriggersService {
  private readonly _userNotificationTriggers: BehaviorSubject<
    IPaginatedResponse<IUserNotificationDetails>
  > = new BehaviorSubject<IPaginatedResponse<IUserNotificationDetails>>(null);
  userNotificationTriggers$ = this._userNotificationTriggers.asObservable();

  private readonly _userNotificationFilters: BehaviorSubject<{
    entityId: string;
    page: number;
    perPage: number;
    notificationTypes: NotificationType[];
    locationIds: string[];
    targetIds: string[];
  }> = new BehaviorSubject<{
    entityId: string;
    page: number;
    perPage: number;
    notificationTypes: NotificationType[];
    locationIds: string[];
    targetIds: string[];
  }>(null);

  userNotificationFilters$ = this._userNotificationFilters.asObservable();

  constructor(
    private _notificationsService: NotificationsApiService,
    private store: Store
  ) {
    store
      .select(getSelectedOrganizationInfo)
      .pipe(pairwise())
      .subscribe(([prev, next]) => {
        if (prev?.id !== next?.id) {
          this.clear();
        }
      });
  }

  clear() {
    this._userNotificationFilters.next(null);
    this._userNotificationTriggers.next(null);
  }

  setFilters(filters: {
    entityId: string;
    page: number;
    perPage: number;
    notificationTypes: NotificationType[];
    locationIds: string[];
    targetIds: string[];
  }) {
    this._userNotificationFilters.next(filters);
  }

  nextPage() {
    const current = this._userNotificationFilters.value;
    if (!current || !this._userNotificationTriggers.value?.nextPage) return of();
    this._userNotificationFilters.next({
      ...current,
      page: this._userNotificationTriggers.value.nextPage,
    });
    return this.loadUserNotifications();
  }

  previousPage() {
    const current = this._userNotificationFilters.value;
    if (!current || !this._userNotificationTriggers.value?.previousPage) return of();
    this._userNotificationFilters.next({
      ...current,
      page: this._userNotificationTriggers.value.previousPage,
    });
    return this.loadUserNotifications();
  }

  loadUserNotifications() {
    const params = this._userNotificationFilters.value;
    if (!params) return;
    const { page = 1, perPage = 25 } = params;
    console.log('Filters', this._userNotificationFilters.value);
    return this._notificationsService
      .getUserNotificationTriggers({ ...params, page, perPage })
      .pipe(
        tap((unt) => {
          this._userNotificationTriggers.next(unt);
        })
      );
  }
}
